import { Select, Stack, Group, Textarea } from "@mantine/core"
import { Form } from "../../../../../-components/typed-form"
import { useQueryGet } from "../../../../../typed-client/hooks/use-query-get"
import { DatePickerInput, DatesRangeValue, TimeInput } from "@mantine/dates"
import { CancelButton, SubmitButton } from "../../../../../-components/Buttons"
import { Nullable, TimeOnly } from "../../../../../@client/System"
import { dateToDateOnly } from "../../../../../utils/date-to-date-only"
import { DefaultError } from "../../../../../-components/error-context"
import { showErrorNotification } from "../../../../../utils/form-submission-notifications"
import { useTranslation } from "react-i18next"
import { ShiftTypeDto } from "../../../../../@client/Theasoft_ApiServer_ShiftTypes"
import {
  hasValidationErrors,
  tryGetValidationErrorsAsMantineErrors,
} from "../../../../../utils/to-mantine-validation-errors"

type AddAbsenceInitialData = {
  shiftTypeId: null | number
  note: null | string
  contractId: number
  range: DatesRangeValue
  startTime: TimeOnly | null
  endTime: TimeOnly | null
}

export function CreateAbsenceModal({
  departmentId,
  initialData,
  onCancel,
  shiftType,
  onAdded,
}: {
  shiftType: ShiftTypeDto
  departmentId: number
  initialData: AddAbsenceInitialData
  onCancel: () => void
  onAdded: () => void
}) {
  const { data } = useQueryGet(
    "/api/ShiftType/GetRequestableAbsenceShiftTypesForDepartment",
    {
      departmentId,
    }
  )
  const { t } = useTranslation("app_server")
  return (
    <Form
      url="/api/DepartmentDutyRoster/AddAbsence"
      initialValues={{
        ...initialData,
        shiftTypeId: shiftType.shiftTypeId.toString(),
      }}
      onSuccess={() => {
        onAdded && onAdded()
      }}
      onError={(e, _, __, f) => {
        if (e instanceof DefaultError && hasValidationErrors(e)) {
          const validationErrors = tryGetValidationErrorsAsMantineErrors(e, t)
          if (validationErrors) {
            f.setErrors(validationErrors)
          }
        }
        showErrorNotification(e)
      }}
      transform={(x) => ({
        startDate: dateToDateOnly(new Date(x.range[0]!)),
        endDate: dateToDateOnly(new Date(x.range[1]!)),
        note: x.note ?? "",
        contractId: initialData.contractId,
        shiftTypeId: parseInt(x.shiftTypeId),
        startTime: (x.startTime
          ? x.startTime + ":00"
          : null) as Nullable<TimeOnly>,
        endTime: (x.endTime ? x.endTime + ":00" : null) as Nullable<TimeOnly>,
      })}
    >
      {(f, _) => (
        <Stack>
          <Select
            required
            label={t("Reason")}
            data={
              data?.map((v) => ({
                label: v.name,
                value: v.shiftTypeId.toString(),
              })) ?? []
            }
            {...f.getInputProps(_.shiftTypeId._PATH_)}
          />
          <DatePickerInput
            type="range"
            {...f.getInputProps(_.range._PATH_)}
            label={t("TimePeriod")}
          />
          <Group>
            <TimeInput
              {...f.getInputProps(_.startTime._PATH_)}
              label={t("From")}
            />
            <TimeInput
              {...f.getInputProps(_.endTime._PATH_)}
              label={t("Until")}
            />
          </Group>
          <Textarea {...f.getInputProps(_.note._PATH_)} label={t("Note")} />
          <Group justify="end">
            <CancelButton onMouseDown={() => onCancel()} />
            <SubmitButton>{t("EnterAbsence")}</SubmitButton>
          </Group>
        </Stack>
      )}
    </Form>
  )
}
